/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 16:21:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 11:24:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/slice/index.ts
 */
import {
  createSlice,
  //createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  //getSearchCondition as _getSearchCondition,
  //reducerTarget,
  getIsSearching as _getIsSearching,
  getSearch as _getSearch,
  getRequestSearch as _getRequestSearch,
  getData as _getData,
  getCollapse as _getCollapse,
  getLoaded as _getLoaded,
  getMoveList as _getMoveList,
  getRootUuid as _getRootUuid,
  getOrder as _getOrder,
} from 'src/pages/SalesChannelCategory/slice/common';
// import //searchConditions,
//   getStateTarget as getTarget,
// 'src/tools/helper';
import {
  getContentCategories,
  postCategoryContentSearch,
} from 'src/request/category';
import { onTagClose1 } from 'src/constrains/Query1/tools';
//import { generateDefaultCategory } from './common';
import { EnumReducers } from 'src/pages/SalesChannelCategory/slice/constants';
import { getState, dispatch } from 'src/store';
import {
  convertDataFromServerToReduxNoSearch,
  convertDataFromServerToReduxHasSearch,
} from 'src/pages/SalesChannelCategory/PagesCategory/tools';

//const getTarget = (state) => reducerTarget(state, [EnumReducers.content]);

// const _isSearching = () => {
//   const state = getState();
//   const isSearching = getIsSearching()(state);

//   return { isSearching };
// };

const resetSearch = () => {
  dispatch(emptySearch());
};

function buildState({ state, data, searchingStatusHasChanged, isSearching }) {
  if (isSearching) {
    convertDataFromServerToReduxHasSearch({
      state,
      data,
      searchingStatusHasChanged, //因为发请求都取消search
    });
  } else {
    convertDataFromServerToReduxNoSearch({
      state,
      data,
      searchingStatusHasChanged,
    });
  }
}

export const fetchCategoriesContent = createAsyncThunk(
  'fetchCategoriesContent',
  async (params: { uuid }, thunkAPI) => {
    const { uuid } = params;

    const response = await getContentCategories(uuid);
    return { response };
  },
);

export const postContentSearch = createAsyncThunk(
  'postCategoryContentSearch',
  async (params: { body }, thunkAPI) => {
    const { body } = params;
    const response = await postCategoryContentSearch(body);
    return { response };
  },
);

const defaultState = {
  isEditing: false,
  search: [],
  //addNewCategoryList: [],
  ///currentEditing: {},
  dataSet: {}, //{uuid:data}
  loaded: false,
  collapseOpen: {},
  rootUuid: null,
  allNodesWithOrder: [], //所有的节点uuid
  order: [], //只有当前显示的顺序
};

const ContentCategory = createSlice({
  name: 'salesChannelContentCategory',
  initialState: defaultState,
  reducers: {
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onSearchChange(state, action) {
      state.search.push(action.payload);
    },
    // onAddNewCategory(state, action) {
    //   const { salesChannelUuid } = action.payload;
    //   const _c = generateDefaultCategory({ salesChannelUuid });
    //   state.addNewCategoryList.push(_c);
    // },
    onSearchTagClose(state, action) {
      const { item } = action.payload;
      onTagClose1({ state, item, conditionKey: undefined });
    },
    onDataUpdate(state, action) {
      const isSearching = state.search.length > 0;

      if (isSearching) {
        state.search = [];
      }
      const { data } = action.payload;

      buildState({
        state,
        data,
        isSearching: false,
        searchingStatusHasChanged: isSearching,
      });
    },
    emptySearch(state) {
      if (state.search.length > 0) state.search = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoriesContent.fulfilled, (state, action) => {
      const { response } = action.payload;
      const isSearching = state.search.length > 0;
      if (isSearching) {
        resetSearch();
      } else {
        buildState({
          state,
          data: response,
          isSearching: false,
          searchingStatusHasChanged: isSearching,
        });
      }
    });

    builder.addCase(postContentSearch.fulfilled, (state, action) => {
      const { response } = action.payload;
      const stillInSearching = state.search.length > 0;
      buildState({
        state,
        data: response,
        isSearching: stillInSearching,
        searchingStatusHasChanged: !stillInSearching,
      });
    });
  },
});

const getIsSearching = () => {
  return _getIsSearching(EnumReducers.content);
};

const getLoaded = () => {
  return _getLoaded(EnumReducers.content);
};

// const isEditing = () => {
//   return createSelector(
//     (state: any) => {
//       const isAdding = getTarget(state).addNewCategoryList.length < 1;
//       const isEditing = !!!Object.keys(getTarget(state).currentEditing).find(
//         (i) => i,
//       );
//       return isAdding && isEditing;
//     },
//     (enable) => {
//       return enable;
//     },
//   );
// };

const getSearch = () => {
  return _getSearch(EnumReducers.content);
};

const getMoveList = (self) => {
  return _getMoveList(EnumReducers.content, self);
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.content, id);
};

const getContent = (id) => {
  return _getData(EnumReducers.content, id);
};

const getRootUuid = () => {
  return _getRootUuid(EnumReducers.content);
};

const getRequestSearch = () => {
  const state = getState();
  const search = _getRequestSearch(EnumReducers.content)(state);
  return search;
};

const getOrder = () => {
  return _getOrder(EnumReducers.content);
};

export const {
  onSearchChange,
  //onAddNewCategory,
  onSearchTagClose,
  emptySearch,
  onCollapseChange,
  onDataUpdate,
} = ContentCategory.actions;
export {
  getIsSearching,
  getSearch,
  getRequestSearch,
  //isEditing,
  getContent,
  getCollapse,
  getLoaded,
  getMoveList,
  getRootUuid,
  getOrder,
};

export default ContentCategory.reducer;
